import React from 'react';
import gallery1 from '../../../assets/images/gallery-1.jpg';
import gallery2 from '../../../assets/images/gallery-2.jpg';
import gallery3 from '../../../assets/images/gallery-3.jpg';
import gallery4 from '../../../assets/images/gallery-4.jpg';
import gallery5 from '../../../assets/images/gallery-5.jpg';

const Gallery = () => {
  return (
    <>
      <div className='bg-[#EDEFFF] py-16'>
        <div className='container mx-auto px-4 md:px-12'>
          <div className='grid grid-cols-1 items-center gap-10 lg:grid-cols-2'>
            {/* Left Side Content */}
            <div className='text-center'>
              <p className='mb-8 text-3xl font-bold text-gray-700 md:text-4xl'>Connect with Us:</p>
              <h1 className='mb-6 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
                Your Journey <br /> Begins Here
              </h1>
              <p className='mb-6 text-lg'>
                Ready to embark on a journey of unparalleled comfort? Contact us for any inquiries,
                assistance, or to share your travel plans. We’re here to turn your hotel stay into a
                highlight of your BlueLagoon Travels adventure.
              </p>
            </div>

            {/* Right Side Gallery */}
            <div className='grid grid-cols-3 gap-4'>
              {/* Left 2 vertical */}
              <div className='flex flex-col gap-4'>
                <img
                  src={gallery1}
                  alt='Gallery 1'
                  className='h-48 w-full rounded-lg object-cover'
                />
                <img
                  src={gallery2}
                  alt='Gallery 2'
                  className='h-48 w-full rounded-lg object-cover'
                />
              </div>

              {/* Middle big */}
              <div>
                <img
                  src={gallery3}
                  alt='Gallery 3'
                  className='h-full w-full rounded-lg object-cover'
                />
              </div>

              {/* Right 2 vertical */}
              <div className='flex flex-col gap-4'>
                <img
                  src={gallery4}
                  alt='Gallery 4'
                  className='h-48 w-full rounded-lg object-cover'
                />
                <img
                  src={gallery5}
                  alt='Gallery 5'
                  className='h-48 w-full rounded-lg object-cover'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Wave SVG */}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 1200 100'
        preserveAspectRatio='none'
        style={{
          backgroundColor: 'transparent',
          display: 'block',
          height: '30px',
          position: 'relative',
          top: '-1px',
          width: '100%',
        }}
      >
        <path
          d='M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z'
          style={{ fill: '#EDEFFF' }}
        />
      </svg>
    </>
  );
};

export default Gallery;
